export default {
    navigationBarTitleText: intl.get('inviteMembers.title')
  };
